import { HttpHeaders } from '@angular/common/http';
import { PagingMetadata } from './model';

export function parsePagingMetadata(headers: HttpHeaders) {
  function getHeader(name: string) {
    const value = headers.get(name);
    if (value) {
      return parseInt(value);
    }
    return null;
  }

  const model: PagingMetadata = {
    page: getHeader('X-Paging-Page'),
    count: getHeader('X-Paging-PageCount'),
    size: getHeader('X-Paging-PageSize'),
    total: getHeader('X-Paging-TotalItems'),
  };
  return model;
}
